import React, { useContext } from "react";
import { LanguageContext } from "./LanguageContext";

const LanguageSelector = () => {
  const { changeLanguage, language } = useContext(LanguageContext);

  return (
    <div
      className="d-flex align-items-center justify-content-end bg-danger px-3 py-1"
      style={{ height: "30px", borderRadius: "0px" }}
    >
      <i
        className="bi bi-translate me-2"
        style={{ color: "#fff", fontSize: "16px" }}
        aria-label="Language selector"
      ></i>

      <div className="d-flex gap-3">
        {/* English */}
        <div
          onClick={() => changeLanguage("English")}
          style={{
            cursor: "pointer",
            color: language === "English" ? "#57a0e0" : "#fff",
            fontWeight: language === "English" ? "bold" : "normal",
            textDecoration: language === "English" ? "underline" : "none",
            fontSize: "14px",
          }}
        >
          English
        </div>

        {/* Amharic */}
        <div
          onClick={() => changeLanguage("Amharic")}
          style={{
            cursor: "pointer",
            color: language === "Amharic" ? "#57a0e0" : "#fff",
            fontWeight: language === "Amharic" ? "bold" : "normal",
            textDecoration: language === "Amharic" ? "underline" : "none",
            fontSize: "14px",
          }}
        >
          አማርኛ
        </div>

        {/* Spanish */}
        <div
          onClick={() => changeLanguage("Spanish")}
          style={{
            cursor: "pointer",
            color: language === "Spanish" ? "#57a0e0" : "#fff",
            fontWeight: language === "Spanish" ? "bold" : "normal",
            textDecoration: language === "Spanish" ? "underline" : "none",
            fontSize: "14px",
          }}
        >
          Español
        </div>
      </div>
    </div>
  );
};

export default LanguageSelector;
